module.exports = __webpack_public_path__ + "img/background-register.91864eef.png";